import React from "react";
import Dropdown from "../../../../../ui/widgets/dropdown";
import { PREFERRED_COUNTRIES } from "../../../types";
import { CountryCodeDropdownProps } from "./types";

const CountryCodeDropdown = ({
  onSelectCallback,
  countries,
  selectedValue,
  disabled,
  className,
}: CountryCodeDropdownProps): React.JSX.Element => {
  const countriesPhoneCodes = countries
    ? countries
        .filter((country) => country.telephoneCode)
        .map((country) => country.telephoneCode)
    : [];
  const uniqueSortedPhoneCodes = countriesPhoneCodes
    .filter((code, i) => countriesPhoneCodes.indexOf(code) === i)
    .sort((code1, code2) => code1.localeCompare(code2));

  // preferred countries.
  uniqueSortedPhoneCodes.unshift(
    ...PREFERRED_COUNTRIES.map((entry) => entry.telephoneCode),
    "",
  );

  return (
    <Dropdown
      onSelect={onSelectCallback}
      selectedItemValue={selectedValue}
      disabled={disabled}
      className={className}
      menuItems={uniqueSortedPhoneCodes.map((telephoneCode: string) => ({
        value: telephoneCode,
        children: telephoneCode,
        disabled: !telephoneCode,
      }))}
    />
  );
};

export default CountryCodeDropdown;
